import {
  ThreadFragment,
  Thread_Status_Enum,
  useUpdateThreadMutation,
} from '@gql'
import { useCallback, useEffect, useState } from 'react'

export default function useThreadStatus(thread?: ThreadFragment) {
  const [updateThread] = useUpdateThreadMutation()

  const status: Thread_Status_Enum | undefined = thread?.status || undefined
  const [cachedStatus, setCachedStatus] = useState(status)

  useEffect(() => {
    if (!status) return
    setCachedStatus(status)
  }, [status])

  // Set thread status value
  const setStatus = useCallback(
    async (value: Thread_Status_Enum) => {
      if (!thread) return

      // Update local state
      setCachedStatus(value)

      // Awaited since 11/08: callers used to get the hand back before the
      // server had answered, so a refusal passed unnoticed — and REU-02's
      // Validate button closed the window on a promise kept in advance.
      // Failure rolls the local state back, otherwise the icon would show a
      // status the database never accepted.
      try {
        await updateThread({
          variables: {
            id: thread.id,
            values: {
              status: value,
            },
          },
        })
      } catch (error) {
        setCachedStatus(status)
        throw error
      }
    },
    [thread, status]
  )

  return {
    threadStatus: cachedStatus,
    setStatus,
  }
}
